import { render, staticRenderFns } from "./OrganizationAdmin.vue?vue&type=template&id=0d632091"
import script from "./OrganizationAdmin.vue?vue&type=script&lang=js"
export * from "./OrganizationAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports